import PropTypes from 'prop-types';
import './switch.css';

const DEFAULT_OPTIONS = ['EN', 'IT'];

function Switch({ value, onChange, options = DEFAULT_OPTIONS }) {
  const selected = value ?? options[0];

  const handleClick = (opt) => {
    if (onChange) {
      onChange(opt);
    }
  };

  return (
    <div className="switch-track" role="group" aria-label="Language selector">
      {/* Sliding thumb */}
      <div
        className={`switch-thumb ${selected === options[options.length - 1] ? 'is-right' : ''}`}
        aria-hidden="true"
      />

      {options.map((opt) => (
        <button
          type="button"
          key={opt}
          className={`switch-option ${selected === opt ? 'active' : ''}`}
          onClick={() => handleClick(opt)}
          role="radio"
          aria-checked={selected === opt}
          aria-label={opt === 'EN' ? 'English' : 'Italian'}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}

Switch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string),
};

export default Switch;
